import {useAppDispatch, useAppSelector} from "../../../redux/redux.hook";
import {shallowEqual} from "react-redux";
import React from "react";
import {selectAdminById, selectAllAdmins} from "./admins.slice";
import {
    createAdminThunk,
    getAdminThunk,
    listAdminsThunk,
    updateAdminStatusThunk,
    updateAdminThunk
} from "./admins.thunk";
import {CreateAdminData, UpdateAdminInput} from "./types";

export function useAdmins() {
    const dispatch = useAppDispatch();
    const admins = useAppSelector(selectAllAdmins, shallowEqual);

    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        dispatch(listAdminsThunk())
            .catch(() => {
            })
            .finally(() => setLoading(false));
    }, [dispatch]);

    return {admins, loading};
}

export function useCreateAdmin() {
    const dispatch = useAppDispatch();
    return {createAdmin: (dto: CreateAdminData) => dispatch(createAdminThunk(dto))};
}

export function useUpdateAdmin() {
    const dispatch = useAppDispatch();
    return {updateAdmin: (id: string, dto: UpdateAdminInput) => dispatch(updateAdminThunk({id, dto}))};
}

export function useUpdateAdminStatus() {
    const dispatch = useAppDispatch();
    return {updateAdminStatus: (id: string, active: boolean) => dispatch(updateAdminStatusThunk({id, active}))};
}

export function useAdmin(id: string) {
    const dispatch = useAppDispatch();

    const admin = useAppSelector((state) => selectAdminById(state, id));
    const error = useAppSelector((state) => state.admins.errors[id]);

    React.useEffect(() => {
        if (!admin && !error) {
            dispatch(getAdminThunk({id}))
        }
    }, [dispatch, error, id, admin])

    return {
        admin,
        error
    }
}